/**
 * @file app.ts
 */
import SanApp, {
    Component as ComponentClass,
    defineComponent,
} from '@src/lib/San';
import __INSTANCE__, {InstanceConfig} from './InstanceManager';
import Store from './Store';
import CustomEventEmitter from './utils/eventEmitter';

interface HulkOptions {
    data: Record<string, unknown>;
    append: boolean;
    config?: InstanceConfig;
    owner?: SanApp.Component | undefined;
}

const hook = (
    app: ComponentClass,
    $node: HTMLElement,
    state: Record<string, unknown>,
    config = {} as InstanceConfig
) => {
    // 全局状态管理
    const store = new Store(state);
    const emitter = new CustomEventEmitter();
    emitter.setMaxListeners(Infinity);

    Object.defineProperty(app, '_store', {
        value: store,
        writable: false,
    });

    Object.defineProperty(app, '_emitter', {
        value: emitter,
        writable: false,
    });

    __INSTANCE__.create(app, {
        config: Object.assign(config, {
            $root: $node,
        }),
    });
};

/**
 *
 * @param {SanComponent} Component san的 component
 * @param {String|DOM} selector attach 的节点
 */
const hulk = (
    Component: ComponentClass,
    selector: string | HTMLElement,
    options = {} as HulkOptions
) => {
    const {data: state, config} = options;
    let app = null;

    if (Component instanceof ComponentClass) {
        app = Component;
    }
    else {
        const AppComponent = defineComponent(Component);
        app = new AppComponent({
            data: options.data,
            owner: options.owner,
        });
    }

    let $node: HTMLElement | null = null;
    switch (typeof selector) {
        case 'string':
            $node = document.querySelector(selector)!;
            break;
        case 'undefined':
            $node = document.body;
            break;
        default:
            if (selector.nodeType && selector.nodeName) {
                $node = selector;
            }
            else {
                throw new Error(selector + ' must be an DOM or DOM-selector!');
            }
    }

    if (!options.append) {
        // bca-disable-line
        $node.innerHTML = '';
    }

    hook(app, $node, state, config);

    app.attach($node);

    return app;
};

export default hulk;
